import LoadingAnimation from 'component/animation/Loading';
import LoadingDualRing from 'component/animation/LoadingDualRing';

export { LoadingAnimation };
export { LoadingDualRing };

export default Object.assign({
    LoadingAnimation,
    LoadingDualRing
})